import clsx from 'clsx'
import React, { ReactNode, useState } from 'react'

import s from './styles.module.scss'

import { Icon } from '../../atoms'

interface CollapsibleProps {
  content: ReactNode
  expendedContent?: ReactNode
  defaultExpended?: boolean
  stopPropagation?: boolean
}
const Collapsible = ({
  content,
  expendedContent,
  defaultExpended = false,
  stopPropagation = true,
}: CollapsibleProps) => {
  const [expanded, setExpanded] = useState<boolean>(defaultExpended)

  return (
    <div
      className={clsx(s.container, { [s.collapsible]: expendedContent })}
      onClick={() => {
        if (expendedContent) {
          setExpanded(!expanded)
        }
      }}
    >
      <div className={s.header}>
        {/*
         * Prevents the collapsible to open when the title is clicked, so we can still copy and paste or click a link
         */}
        <div
          className={s.label}
          onClick={(e) => {
            if (stopPropagation) {
              e.stopPropagation()
            }
          }}
        >
          {content}
        </div>
        {expendedContent && (
          <span className={clsx(s.icon, { [s.expanded]: expanded })}>
            <Icon name='arrow-down' size={10} />
          </span>
        )}
      </div>
      {expendedContent && (
        <div className={clsx(s.wrapper, { [s.wrapperExpanded]: expanded })}>
          <div className={s.inner}>
            <>
              {typeof expendedContent === 'string' ? (
                <p>{expendedContent}</p>
              ) : (
                <>{expendedContent}</>
              )}
            </>
          </div>
        </div>
      )}
    </div>
  )
}

export default Collapsible
